import React from 'react';
import { Heart } from 'lucide-react';
import { team } from '../mock';
import BotanicalDecor from './BotanicalDecor';

export default function Team() {
  return (
    <section id="team" className="section relative overflow-hidden">
      <BotanicalDecor style={{ top: 40, left: -40, width: 160, height: 380 }} />
      <div className="container-x relative" style={{ zIndex: 1 }}>
        <div className="text-center max-w-[720px] mx-auto reveal">
          <p className="eyebrow mb-2">Meet Our Caregivers</p>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.1rem)' }}>The friendly faces behind the care</h2>
          <p className="mt-5" style={{ color: 'var(--muted)' }}>
            Every caregiver is thoughtfully screened, trained, and matched to your family &mdash; because
            the right person makes all the difference. Here are a few of the wonderful people who make
            our care feel like home.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {team.map((m) => (
            <div
              key={m.name}
              className="reveal bg-white rounded-[26px] overflow-hidden transition-all duration-300 hover:-translate-y-1.5 text-center"
              style={{ border: '1px solid var(--line)', boxShadow: '0 18px 40px -30px rgba(30,59,44,0.5)' }}
            >
              <div className="pt-8 pb-2 px-6 relative" style={{ background: 'linear-gradient(180deg, var(--sage-soft) 0%, #fff 100%)' }}>
                <span className="absolute top-4 right-4 text-xs font-semibold px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--sage)', color: 'var(--forest)' }}>
                  {m.years}
                </span>
                <div className="mx-auto rounded-full overflow-hidden" style={{ width: 132, height: 132, border: '4px solid #fff', boxShadow: '0 10px 26px -12px rgba(30,59,44,0.5)' }}>
                  <img src={m.image} alt={`${m.name}, ${m.role}`} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="p-6 pt-4">
                <h3 className="text-xl">{m.name}</h3>
                <div className="flex items-center justify-center gap-1.5 text-sm mt-0.5" style={{ color: '#5B8C4E' }}>
                  <Heart size={14} /> {m.role}
                </div>
                <p className="mt-3 text-[14px]" style={{ color: 'var(--muted)' }}>{m.bio}</p>
                <div className="flex flex-wrap justify-center gap-2 mt-4">
                  {m.specialties.map((s) => (
                    <span key={s} className="text-xs px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--cream-2)', color: 'var(--forest)', border: '1px solid var(--line)' }}>{s}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
